// created_in_lomavis

import Image from 'react-bootstrap/Image';
import { useSelector } from 'react-redux';
import { COMPACT_MODE_HEIGHT } from '../contants';
import { PREVIEW_TYPE_COMPACT } from '../../config/constants';

const ImportedPostsMediaPreview = ({ platform, mediaFiles }: any): any => {
  const {
    ui: { previewMode },
    postData: {
      [platform]: { platform_url }
    }
  } = useSelector((state: any) => state.lomavisCreator);

  if (!platform_url) return null;
  if (mediaFiles.length === 0) return null;

  return (
    <div className="position-relative">
      {mediaFiles[0].type === 'video' && (
        <div
          className="position-absolute top-50 start-50 translate-middle"
          style={{ zIndex: 2 }}
        >
          <i
            className="fas fa-play"
            style={{ fontSize: '3rem', color: '#fff' }}
            onClick={() => window.open(platform_url, '_blank')}
          ></i>
        </div>
      )}
      <Image
        onClick={() => window.open(platform_url, '_blank')}
        className="img-fluid w-100 h-100 rounded"
        alt="imported post"
        style={{
          objectFit: 'contain',
          backdropFilter: 'blur(5px)',
          maxHeight:
            previewMode === PREVIEW_TYPE_COMPACT ? COMPACT_MODE_HEIGHT : '100%'
        }}
        src={mediaFiles[0].image_url}
      />
    </div>
  );
};

export default ImportedPostsMediaPreview;
